require('./blocks/calendar-item.less');
require('./blocks/digest/digest');
require('./blocks/video-item.less');
require('./blocks/cat-slider/cat-slider');
require('./blocks/product/product');
require('./blocks/catalog.less');
require('./blocks/filter/filter');
require('./blocks/priceslider/priceslider');
require('./blocks/pagination.less');
require('./blocks/reviews/reviews');
require('./blocks/review.less');
require('./blocks/seo-catalog.less');
require('./blocks/catalog.js');
require('./blocks/filter-price/filter-price.less');



// WEBPACK FOOTER //
// ./brand.js